// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"88bd5ff5","239":"26bc3779","453":"bdd41670","732":"20c7e531"}[chunkId] + ".chunk.js";
};